import {
    FETCH_TRACKING_SUCCESS,
    EDIT_TRACKING_SUCCESS,
} from '../actions/type';

const INITIAL_STATE = {
    notes: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_TRACKING_SUCCESS:
            return {
                ...state,
                notes: action.payload,
            };
        case EDIT_TRACKING_SUCCESS:
            return {
                ...state,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/tracking_reducer.js